import { render, staticRenderFns } from "./Wordpress.vue?vue&type=template&id=32c2dd18&scoped=true&"
import script from "./Wordpress.vue?vue&type=script&lang=js&"
export * from "./Wordpress.vue?vue&type=script&lang=js&"
import style0 from "./Wordpress.vue?vue&type=style&index=0&id=32c2dd18&lang=scss&scoped=true&"
import style1 from "./Wordpress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c2dd18",
  null
  
)

export default component.exports